<template>
  <error-component v-bind="$attrs">
    <template #default="{touch, faulty}">
      <input 
        type="number"
        class="inp"
        inputmode="decimal"
        ref="input"
        v-bind="$attrs"
        :value="intValue"
        :class="{faulty}"
        @input="onInput"
        @blur="onBlur(); touch();"
      />
    </template>
  </error-component>
</template>

<script>
import ErrorComponent from "@/components/ErrorComponent";

export default {
  props: {
    value: Number,
  },
  data() {
    return {
      intValue: this.value
    }
  },
  watch: {
    value(nv, ov) {
      nv = parseInt(nv)
      if(nv != ov) {
        this.intValue = nv
      }
    }
  },
  components: {
    ErrorComponent
  },
  methods: {
    onInput($event) {
      const val = parseInt($event.target.value)
      if(isNaN(val)) {
        $event.preventDefault()
        return false
      }
      this.$refs.input.value = val
      this.intValue = val
      this.$emit('input', this.intValue)
    },
    onBlur() {
      this.$refs.input.value = this.intValue ? this.intValue : ''
    }
  }
}
</script>

<style>

</style>